import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-2 16h-9v-6h9v6z"
}), 'BrandingWatermarkSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BrandingWatermarkSharp.js
// module id = 2471
// module chunks = 2